import { useLocation } from "react-router";
import { useEffect, useRef } from "react";
import { usePaybookPaymentAwaitedMutation } from "@/store/api/bee.payment.api";
import { Loader } from "@/components/Loader/Loader";
import { useAppContext } from "@/context/AppContext/Context";
import { FlashNotifications } from "@/components/Notification/FlashNotifications";
import { BookingLoadError } from "@/components/BookingLoadError";

export const PaybookRedirectPage = () => {
  const { pathname, search } = useLocation();
  const isApproved = pathname.includes("/paybook/approved");

  const contextParams = useAppContext().params;
  const routeParams = new URLSearchParams(search);
  const token = routeParams.get("token") ?? contextParams.token ?? "";
  const paymentSessionId =
    routeParams.get("payment_session_id") ??
    contextParams.payment_session_id ??
    "";
  const paymentId =
    routeParams.get("paymentId") ?? contextParams.paymentId ?? "";

  const [completeReturn, { data, isUninitialized, isLoading, isError }] =
    usePaybookPaymentAwaitedMutation();
  const startedReturn = useRef<string | undefined>(undefined);
  const returnKey = JSON.stringify([token, paymentSessionId, paymentId, isApproved]);

  useEffect(() => {
    if (!paymentSessionId || startedReturn.current === returnKey) return;
    startedReturn.current = returnKey;
    void completeReturn({
      token,
      payment_session_id: paymentSessionId,
      paymentId,
      isApproved,
    });
  }, [completeReturn, token, paymentSessionId, paymentId, isApproved, returnKey]);

  const hasPaymentStatusLoading = isLoading || isUninitialized;

  if (isError) {
    return <BookingLoadError onRetry={() => completeReturn({
      token,
      payment_session_id: paymentSessionId,
      paymentId,
      isApproved,
    })} />;
  }
  if (hasPaymentStatusLoading) return <Loader />;

  return (
    <FlashNotifications
      shouldScrollToRef
      flashNotifications={data?.flashNotifications}
    />
  );
};
